module.exports = __webpack_public_path__ + "icon-logo-developer-50b7f1cf7b2a6cee287259c14f78d99b.svg";